import { DocStatus } from '../config/document';
import { DocumentType } from '../config/DocumentType';
import { ElectronicInvoiceMethod } from '../config/electronicInvoice';

export const isElectronicInvoiceHashMethod = (config, documentTypeId) =>
  [DocumentType.DownPayment, DocumentType.ARInvoice, DocumentType.ARInvoiceModification].includes(
    Number(documentTypeId)
  ) && config?.electronicInvoiceMethod === ElectronicInvoiceMethod.NAV_HASH;

export const isDocumentSigningEnabled = (config, documentTypeId, electronicSignatureEnabled) =>
  isElectronicInvoiceHashMethod(config, documentTypeId) || Boolean(electronicSignatureEnabled);

export const isElectronicInvoiceDocument = (document, documentTypeId = document?.docTypeId) =>
  Boolean(
    [DocumentType.DownPayment, DocumentType.ARInvoice, DocumentType.ARInvoiceModification].includes(
      Number(documentTypeId)
    ) && document?.electronicSignatureRequested
  );

export const shouldPrepareSignedDocumentAfterSave = (document, previousStatus) =>
  Boolean(
    document?.docId &&
      document.electronicSignatureRequested &&
      [DocStatus.OPENED, DocStatus.CLOSED].includes(document.docStatus) &&
      (previousStatus == null || previousStatus === DocStatus.PLANNED)
  );

export const isDigitalSigningConfigured = (config, documentTypeId) => {
  if (!config?.digitalSigningEnabled) return false;
  if (isElectronicInvoiceHashMethod(config, documentTypeId)) return true;
  if (typeof config.eszignoServerProfileId !== 'string' || !config.eszignoServerProfileId.trim()) return false;
  try {
    const url = new URL(config.eszignoServerUrl ?? '');
    const timeout = config.eszignoServerTimeoutMs ?? 120000;
    return (
      url.href.length <= 2048 &&
      ['http:', 'https:'].includes(url.protocol) &&
      !url.username &&
      !url.password &&
      !url.search &&
      !url.hash &&
      config.eszignoServerProfileId.length <= 255 &&
      Number.isInteger(timeout) &&
      timeout >= 1000 &&
      timeout <= 300000 &&
      (!config.eszignoServerPassword || Boolean(config.eszignoServerUsername)) &&
      (!config.eszignoServerUsername || config.eszignoServerUsername.length <= 255)
    );
  } catch {
    return false;
  }
};
